// 存数据到本地
export function setStorage(key,value){
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(key,value)
}
// 取数据
export function getStorage(key){
    let data = window.localStorage.getItem(key)
    try {
        return JSON.parse(data)
    } catch (error) {
        return data;
    }
}
//删除本地存储对应的数据
export function removeStorage(key){
    window.localStorage.removeItem(key)
}
//清空本地存储
export function removeAllStorage(){
    window.localStorage.clear()
}

